module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_5.ebeb9061.png";